
























import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import { UserHelper } from '../../helper/user';
import DepositPartInfoToolTip from '@/components/deposit-part-info-tooltip/DepositPartInfoToolTip.vue';

@Component({
    components: {
        DepositPartInfoToolTip,
    },
})
export default class Price extends Mixins(BaseMixin) {
    @Prop(String)
    private priceNetCents!: number;
    @Prop(String)
    private priceGrossCents!: number;
    @Prop(String)
    private priceDiscountedNetCents!: number;
    @Prop(String)
    private depositPartPriceNetCents?: number;
    @Prop(String)
    private depositPartPriceGrossCents?: number;
    @Prop(String)
    private depositPartPriceDiscountedNetCents?: number;
    @Prop(Boolean)
    private rightAligned!: boolean;
    @Prop(Boolean)
    private noWrap!: boolean;
    @Prop(Boolean)
    private isHidden!: boolean;
    @Prop(String)
    private currencySymbol!: string;
    @Prop(Boolean)
    private hasSubunit!: boolean;

    private hasCustomerDiscounts: boolean = UserHelper.hasDiscounts();

    public get bigFontPrice(): number {
        return this.hasCustomerDiscounts ? this.priceDiscountedNetCents : this.priceGrossCents;
    }

    public get smallFontPrice(): number {
        return this.priceNetCents;
    }

    public get showSmallPrice(): boolean {
        return this.smallFontPrice !== this.bigFontPrice;
    }

    public get showNetGrossPrefix(): boolean {
        return this.hasCustomerDiscounts ? false : this.showSmallPrice;
    }

    public get hasDepositPart(): boolean {
        return (
            (this.depositPartPriceNetCents != null && this.depositPartPriceNetCents >= 0) ||
            (this.depositPartPriceGrossCents != null && this.depositPartPriceGrossCents >= 0) ||
            (this.depositPartPriceDiscountedNetCents != null && this.depositPartPriceDiscountedNetCents >= 0)
        );
    }
}
